import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CoreModule } from './core/core.module';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { LoginModule } from './login/login.module';
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { Dashboard } from './dashboard/dashboard';
import { DocumentsComponent } from './documents/documents.component';
import { MasterDataComponent } from './master-data/master-data.component';
import { UserDataComponent } from './user-data/user-data.component';
import { CustomerAccountComponent } from './customer-account/customer-account.component';
import { ManagementComponent } from './management/management.component';
import { SettingsComponent } from './settings/settings.component';
// import { BlocklistComponent } from './blocklist/blocklist.component';
import { OrdersComponent } from './orders/orders.component';
import { OrderDetailComponent } from './order-detail/order-detail.component';
import { CanDeactivateGuard } from './can-deactivate-guard.service';
import { DatePipe } from '@angular/common';
import { AuthGuard } from './auth/auth.guard'
import { AuthMasterGuard } from './auth/auth-master.guard'
import { ReportingComponent } from './reporting/reporting.component';
import { CaseList } from './cases/case-list';

const appRoutes: Routes = [
//   { path: 'contact', component: PageNotFoundComponent },
//   { path: 'logout', component: PageNotFoundComponent },
  { path: 'Startseite', component: Dashboard/*, canActivate: [AuthGuard]*/},
  { path: 'Dokumente', component: DocumentsComponent, canActivate: [AuthGuard] },
  { path: 'Stammdaten', component: MasterDataComponent, canActivate: [AuthMasterGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'Userdaten', component: UserDataComponent, canActivate: [AuthGuard]},
  { path: 'Kundenkonto', component: CustomerAccountComponent, canActivate: [AuthGuard] },
  { path: 'Dossier', component: CaseList, canActivate: [AuthGuard] },
  { path: 'Auftraege', component: OrdersComponent, canActivate: [AuthGuard] },
  // { path: 'Blocklist', component: BlocklistComponent, canActivate: [AuthGuard] },
  { path: 'Verwaltung', component: ManagementComponent, canActivate: [AuthMasterGuard] },
  { path: 'Reporting', component: ReportingComponent, canActivate: [AuthMasterGuard] },
  { path: 'Auftrag', component: OrderDetailComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'Auftrag/:id', component: OrderDetailComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'Kundeneinstellungen', component: SettingsComponent, canActivate: [AuthGuard], canDeactivate: [CanDeactivateGuard] },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: '', redirectTo: '/Startseite', pathMatch: 'full', /*canActivate: [AuthGuard],*/ canDeactivate: [CanDeactivateGuard] },
  { path: '**',  redirectTo: '' }
];


@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes),
    CoreModule,
    LoginModule,
    ReactiveFormsModule ,
    FormsModule
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useValue: 'de-CH'
    },
    DatePipe
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {
}
